"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Feuerwehr = _interopRequireDefault(require("./Feuerwehr"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The Nutzer model module.
 * @module model/Nutzer
 * @version 0.0.1
 */
class Nutzer {
  /**
   * Constructs a new <code>Nutzer</code>.
   * @alias module:model/Nutzer
   * @param email {String} 
   * @param vorname {String} 
   * @param nachname {String} 
   * @param telefon {String} 
   * @param role {String} 
   * @param id {String} 
   */
  constructor(email, vorname, nachname, telefon, role, id) {
    Nutzer.initialize(this, email, vorname, nachname, telefon, role, id);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, email, vorname, nachname, telefon, role, id) {
    obj['email'] = email;
    obj['vorname'] = vorname;
    obj['nachname'] = nachname;
    obj['telefon'] = telefon;
    obj['role'] = role;
    obj['id'] = id;
  }

  /**
   * Constructs a <code>Nutzer</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Nutzer} obj Optional instance to populate.
   * @return {module:model/Nutzer} The populated <code>Nutzer</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Nutzer();
      if (data.hasOwnProperty('email')) {
        obj['email'] = _ApiClient.default.convertToType(data['email'], 'String');
      }
      if (data.hasOwnProperty('vorname')) {
        obj['vorname'] = _ApiClient.default.convertToType(data['vorname'], 'String');
      }
      if (data.hasOwnProperty('nachname')) {
        obj['nachname'] = _ApiClient.default.convertToType(data['nachname'], 'String');
      }
      if (data.hasOwnProperty('telefon')) {
        obj['telefon'] = _ApiClient.default.convertToType(data['telefon'], 'String');
      }
      if (data.hasOwnProperty('role')) {
        obj['role'] = _ApiClient.default.convertToType(data['role'], 'String');
      }
      if (data.hasOwnProperty('feuerwehr_id')) {
        obj['feuerwehr_id'] = _ApiClient.default.convertToType(data['feuerwehr_id'], 'Number');
      }
      if (data.hasOwnProperty('verwalter_feuerwehr_ids')) {
        obj['verwalter_feuerwehr_ids'] = _ApiClient.default.convertToType(data['verwalter_feuerwehr_ids'], [Object]);
      }
      if (data.hasOwnProperty('feuerwehr')) {
        obj['feuerwehr'] = _Feuerwehr.default.constructFromObject(data['feuerwehr']);
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>Nutzer</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Nutzer</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of Nutzer.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
      throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
    }
    // ensure the json data is a string
    if (data['vorname'] && !(typeof data['vorname'] === 'string' || data['vorname'] instanceof String)) {
      throw new Error("Expected the field `vorname` to be a primitive type in the JSON string but got " + data['vorname']);
    }
    // ensure the json data is a string
    if (data['nachname'] && !(typeof data['nachname'] === 'string' || data['nachname'] instanceof String)) {
      throw new Error("Expected the field `nachname` to be a primitive type in the JSON string but got " + data['nachname']);
    }
    // ensure the json data is a string
    if (data['telefon'] && !(typeof data['telefon'] === 'string' || data['telefon'] instanceof String)) {
      throw new Error("Expected the field `telefon` to be a primitive type in the JSON string but got " + data['telefon']);
    }
    // ensure the json data is a string
    if (data['role'] && !(typeof data['role'] === 'string' || data['role'] instanceof String)) {
      throw new Error("Expected the field `role` to be a primitive type in the JSON string but got " + data['role']);
    }
    // ensure the json data is an array
    if (!Array.isArray(data['verwalter_feuerwehr_ids'])) {
      throw new Error("Expected the field `verwalter_feuerwehr_ids` to be an array in the JSON data but got " + data['verwalter_feuerwehr_ids']);
    }
    // validate the optional field `feuerwehr`
    if (data['feuerwehr']) {
      // data not null
      _Feuerwehr.default.validateJSON(data['feuerwehr']);
    }
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    return true;
  }
}
Nutzer.RequiredProperties = ["email", "vorname", "nachname", "telefon", "role", "id"];

/**
 * @member {String} email
 */
Nutzer.prototype['email'] = undefined;

/**
 * @member {String} vorname
 */
Nutzer.prototype['vorname'] = undefined;

/**
 * @member {String} nachname
 */
Nutzer.prototype['nachname'] = undefined;

/**
 * @member {String} telefon
 */
Nutzer.prototype['telefon'] = undefined;

/**
 * @member {String} role
 */
Nutzer.prototype['role'] = undefined;

/**
 * @member {Number} feuerwehr_id
 */
Nutzer.prototype['feuerwehr_id'] = undefined;

/**
 * @member {Array.<Object>} verwalter_feuerwehr_ids
 */
Nutzer.prototype['verwalter_feuerwehr_ids'] = undefined;

/**
 * @member {module:model/Feuerwehr} feuerwehr
 */
Nutzer.prototype['feuerwehr'] = undefined;

/**
 * @member {String} id
 */
Nutzer.prototype['id'] = undefined;
var _default = exports.default = Nutzer;